<template>
  <tela-component
    title="Insumos/Veterinária - Emissão de Pedidos"
    rota="/selecionar-tipo-pedido/emissao"
  >
    <v-progress-linear
      indeterminate
      color="primary"
      v-if="loading"
    ></v-progress-linear>
    <template v-else>
      <v-overlay v-if="emitindoPedido || adicionandoProduto" opacity=".7">
        <p class="text-center">
          <v-progress-circular
            indeterminate
            size="50"
            width="1.5"
          ></v-progress-circular>
        </p>
        <p class="title" v-if="emitindoPedido">Emitindo pedido...</p>
        <p class="title" v-else-if="adicionandoProduto">
          Adicionando produto...
        </p>
      </v-overlay>
      <selecionar-cliente-pedido />
      <template v-if="novopedido.cliente">
        <card-dados-iniciais-insumos class="mt-3" />
        <card-itens-pedido-insumos class="mt-3" />
        <card-outros-dados-pedido-insumos class="mt-3" />
        <btn-finalizar-pedido-insumos />
      </template>
    </template>
  </tela-component>
</template>

<script>
import TelaComponent from "@/components/tela/TelaComponent.vue";
import SelecionarClientePedido from "@/components/pedidos/novo-pedido/SelecionarClientePedido.vue";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import CardDadosIniciaisInsumos from "@/components/pedidos/novo-pedido-insumos/cards/CardDadosIniciaisInsumos.vue";
import CardItensPedidoInsumos from "@/components/pedidos/novo-pedido-insumos/cards/CardItensPedidoInsumos.vue";
import CardOutrosDadosPedidoInsumos from "@/components/pedidos/novo-pedido-insumos/cards/CardOutrosDadosPedidoInsumos.vue";
import BtnFinalizarPedidoInsumos from "@/components/pedidos/novo-pedido-insumos/botoes/BtnFinalizarPedidoInsumos.vue";

export default {
  watch: {
    ["novopedido.cliente"]: function (value) {
      this.limparProdutosAdicionados();
      this.pedido_item.cliente = value;
      if (this.pedido_item.cliente.cadpros.length > 0) {
        this.pedido_item.cadproSelecionado =
          this.pedido_item.cliente.cadpros[0];
      } else {
        this.pedido_item.cadproSelecionado = null;
      }
    },
  },
  computed: {
    ...mapState("pedidos", ["novopedido"]),
    ...mapState("insumos", [
      "pedido_item",
      "emitindoPedido",
      "adicionandoProduto",
      "produtosDisponiveis",
      "filiais",
      "config",
    ]),
  },
  components: {
    TelaComponent,
    SelecionarClientePedido,
    CardDadosIniciaisInsumos,
    CardItensPedidoInsumos,
    CardOutrosDadosPedidoInsumos,
    BtnFinalizarPedidoInsumos,
  },
  data: () => ({
    loading: true,
  }),
  methods: {
    ...mapGetters("sistema", ["device"]),
    ...mapGetters("pedidos", ["clienteBloqueado"]),
    ...mapMutations("insumos", [
      "setPedidoItem",
      "limparProdutosAdicionados",
      "setAtualizarDadosInsumos",
    ]),
    ...mapActions("insumos", [
      "getCulturas",
      "getDadosInsumos",
      "setarDadosInsumosOffline",
    ]),
    isMobile() {
      return this.$mq == "sm";
    },
  },
  async mounted() {
    this.loading = true;
    if (navigator.onLine) {
      await this.getCulturas();
    }

    if (this.produtosDisponiveis.length == 0) {
      if (this.isMobile()) {
        await this.setarDadosInsumosOffline();
      }
      if (this.produtosDisponiveis.length == 0) {
        this.setAtualizarDadosInsumos(true);
        await this.getDadosInsumos();
        this.setAtualizarDadosInsumos(false);
      }
    }

    this.loading = false;
  },
};
</script>

<style>
</style>